import React from 'react';
import { Route } from 'react-router-dom';
import Header from './Header';
import Nav from './Nav';
import routes from './routes';
import './_app.scss';
import UserContext from '../UserContext';

// This component uses UserContext to show a viable alternative to Redux for sharing global data.
// Check out Header.js to see the user data consumed.
class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        id: 1,
        name: 'Bob'
      },
      setUser: this.setUser
    };
  }

  // This way any UserContext.Consumer could access the setter to change the user.
  setUser = user => {
    this.setState({ user });
  };

  render() {
    return (
      <UserContext.Provider value={this.state}>
        <div className="main-layout">
          <div id="wrapper" className="content">
            <Header />

            <Nav links={routes} />

            <div className="page-wrapper">
              {routes.map(route => (
                <Route
                  key={route.path}
                  path={route.path}
                  exact={route.exact}
                  component={route.main}
                />
              ))}
            </div>
          </div>
        </div>
      </UserContext.Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js